// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__fian3","header":"ReportDetails_header__2wen0","title":"ReportDetails_title__MOQ8x","left":"ReportDetails_left__2geRI"};